import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { Subscription, Unsubscribable } from 'rxjs';
import { delay, startWith } from 'rxjs/operators';
import { GridTableComponent, isGridRowGroup } from '../grid/grid-table/grid-table.component';

// This is tested by ViewAssetTransactions

enum GridExpandCollapse {
  Expanded = 'expanded',
  Collapsed = 'collapsed',
}

@Component({
  selector: 'app-grid-expand-collapse-button',
  templateUrl: './grid-expand-collapse-button.component.html',
  styleUrls: ['./grid-expand-collapse-button.component.scss'],
  standalone: false,
})
export class GridExpandCollapseButtonComponent<T extends {}> implements OnDestroy {
  @Input() key?: string;

  private _grid: GridTableComponent<T>;
  @Input() set grid(value: GridTableComponent<T>) {
    if (this._grid !== value) {
      this._grid = value;
      this.onSourceChange();
    }
  }

  @Input() size?: 'small';

  allExpanded = true;
  allCollapsed = true;
  initialGroupDefaultExpanded?: number;

  private _source?: GridTableComponent<T>;
  get source() {
    return this._source ?? this._grid;
  }

  private subscriptions: Subscription[] = [];

  constructor(private cd: ChangeDetectorRef) {}

  register(source: GridTableComponent<T>): Unsubscribable {
    this._source = source;
    this.onSourceChange();

    return {
      unsubscribe: () => {
        if (this._source === source) {
          this._source = undefined;
          this.onSourceChange();
        }
      },
    };
  }

  private onSourceChange() {
    this.subscriptions.forEach(s => s.unsubscribe());
    this.subscriptions = [];

    const source = this.source;

    if (!source) {
      this.allExpanded = true;
      this.allCollapsed = true;
      return;
    }

    if (this.key) {
      const initExpandCollapse = localStorage.getItem(
        `gridExpandCollapse-${this.key}`,
      ) as GridExpandCollapse | null;

      if (initExpandCollapse) {
        this.setGridDefault(initExpandCollapse);
      }
    }

    this.subscriptions.push(
      source.rowGroupExpandCollapse.pipe(startWith(null), delay(1)).subscribe(() => {
        this.allExpanded = true;
        this.allCollapsed = true;

        const setForRows = (rowData: readonly any[] | undefined) =>
          rowData?.forEach(row => {
            if (isGridRowGroup(row)) {
              if (!row.key) {
                setForRows(row.children);
              } else if (row.open) {
                this.allCollapsed = false;
                setForRows(row.children);
              } else {
                this.allExpanded = false;
              }
            }
          });

        setForRows(source.groupedData);

        this.cd.detectChanges();

        // this.setGridDefault(
        //   this.allExpanded && !this.allCollapsed
        //     ? GridExpandCollapse.Expanded
        //     : !this.allExpanded && this.allCollapsed
        //     ? GridExpandCollapse.Collapsed
        //     : undefined,
        // );

        if (this.key) {
          /**
           * If the grid is all expanded or all collapsed then save that, otherwise reset to default
           */
          if (this.allExpanded !== this.allCollapsed) {
            localStorage.setItem(
              `gridExpandCollapse-${this.key}`,
              this.allExpanded ? GridExpandCollapse.Expanded : GridExpandCollapse.Collapsed,
            );
          } else {
            localStorage.removeItem(`gridExpandCollapse-${this.key}`);
          }
        }
      }),
    );
  }

  private setGridDefault(expandCollapse?: GridExpandCollapse) {
    // if (!(this.source instanceof AgGridAngular)) {
    return;
    // }
    // const gridOptions = this.source.gridOptions;

    // if (
    //   gridOptions &&
    //   this.initialGroupDefaultExpanded == null &&
    //   gridOptions.groupDefaultExpanded != null
    // ) {
    //   this.initialGroupDefaultExpanded = gridOptions.groupDefaultExpanded;
    // }

    // let groupDefaultExpanded = this.initialGroupDefaultExpanded;
    // switch (expandCollapse) {
    //   case GridExpandCollapse.Expanded:
    //     if (!this.initialGroupDefaultExpanded) {
    //       groupDefaultExpanded = -1;
    //     }
    //     break;

    //   case GridExpandCollapse.Collapsed:
    //     groupDefaultExpanded = 0;
    //     break;

    //   default:
    //     break;
    // }

    // this.source.groupDefaultExpanded = groupDefaultExpanded;
    // if (gridOptions) {
    //   gridOptions.groupDefaultExpanded = groupDefaultExpanded;
    // }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  onExpandAll() {
    this.expandCollapseAll(true);
  }
  onCollapseAll() {
    this.expandCollapseAll(false);
  }

  private expandCollapseAll(expanded: boolean) {
    const expandCollapseRows = (rows: readonly any[]) =>
      rows.forEach(row => {
        if (isGridRowGroup(row)) {
          if (row.key) {
            row.open = expanded;
          }

          if (row.children) {
            expandCollapseRows(row.children);
          }
        }
      });

    expandCollapseRows(this.source.groupedData);

    this.source.rowGroupExpandCollapse.emit();

    this.allExpanded = expanded;
    this.allCollapsed = !expanded;
  }
}
